var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { SignalClientService } from '../services/basics/signal-client.service';
import { autoinject } from "aurelia-dependency-injection";
import { BaseWidget } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import { QueriesClientService } from "../services/queries/queries-client.services";
import { QueryFilterUriConverter } from "../views/components/converters/queries/query-filter";
import { InitFilterValueConverter } from "../views/components/converters/queries/init-filter";
import * as Enumerable from 'linq';
import { ChartTypes } from "../views/components/chart/chart";
import { EntityTypeConfigurationHelper } from "../models/basics/basics.models";
import { DataType, QueryFilter } from "../models/queries/queries.models";
import { CacheClient, CacheKeys, CacheLocation } from "../services/basics/client-caching.service";
import { QueriesEditor } from '../views/components/queries/queries-editor';
var jsonlint = require("./../services/basics/jsonlint.js");
import moment from "moment";
import { DialogClientService } from "../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../constants/basics/dialog.constants";
import { CloneUtility } from "../utilities/clone";
var ChartWidget = /** @class */ (function (_super) {
    __extends(ChartWidget, _super);
    function ChartWidget(queriesService, entityTypeConfigurationHelper, initFilterConverter, cache, dialogClientService, signalClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.queriesService = queriesService;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.initFilterConverter = initFilterConverter;
        _this.cache = cache;
        _this.dialogClientService = dialogClientService;
        _this.chartData = null;
        _this.entityTypes = _this.entityTypeConfigurationHelper.getConfiguration([]);
        _this.yConverter = function (value) { return value; };
        _this.hideLegend = false;
        _this.isLoading = true;
        _this.filterProperties = new Array();
        _this.nameProperties = new Array();
        return _this;
    }
    Object.defineProperty(ChartWidget.prototype, "responsive", {
        get: function () {
            return this.type == ChartTypes.Pie || this.type == ChartTypes.Donut || this.type == ChartTypes.AreaChart;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartWidget.prototype, "chart", {
        get: function () {
            return this._chart;
        },
        set: function (value) {
            this._chart = value;
        },
        enumerable: false,
        configurable: true
    });
    ChartWidget.prototype.onActivate = function (model) {
        var _this = this;
        this.type = model.chartType;
        this.title = model.title;
        this.hideLegend = model.hideLegend;
        this.reloadData();
        this.queriesService.getQueryOperators()
            .then(function (x) { return _this.operators = x; });
        this.queriesService.getEntityModels().then(function (x) {
            var entityModel = Enumerable.from(x).first(function (a) { return a.uri && a.uri == model.entityTypeUri; });
            _this.filterProperties = entityModel.filterProperties;
            _this.nameProperties = entityModel.projectionProperties;
            if (model.drillDownRuleScript) {
                _this.drillDownRuleToApply = jsonlint.parse(model.drillDownRuleScript);
                if (_this.drillDownRuleToApply) {
                    _this.drillDownQueryModel = Enumerable.from(x).firstOrDefault(function (a) { return a.uri && a.uri == _this.drillDownRuleToApply.queryModelUri; });
                }
            }
        });
    };
    ChartWidget.prototype.reloadData = function () {
        var _this = this;
        this.isLoading = true;
        var model = this.model;
        var entityType = this.entityTypes.filter(function (x) { return x.uri && x.uri.replace(/\s/g, "") === _this.model.entityTypeUri.replace(/\s/g, ""); })[0];
        var converter = entityType && entityType.converters && model.aggrigationProperty ? entityType.converters.filter(function (x) { return x.property == model.aggrigationProperty.name; })[0] : null;
        this.yConverter = function (value) {
            if (converter) {
                return converter.func(value, null, null);
            }
            else if (model.aggrigationType == "sum") {
                return value ? Number(value).toFixed(2) : value;
            }
            return value;
        };
        if (entityType && this.model.nameProperty) {
            if (this.type == ChartTypes.StackedHorizontalBar || this.type == ChartTypes.StackedBar) {
                var promises = Enumerable.from(model.multiQueryFilters)
                    .select(function (x) {
                    var url = _this.getUrl(model, x);
                    return new Promise(function (resolve, reject) {
                        _this.queriesService.getGroupedDataUri(url).then(function (a) {
                            resolve({
                                result: a,
                                title: x.title
                            });
                        }, reject);
                    });
                })
                    .toArray();
                Promise.all(promises).then(function (results) {
                    _this.chartData = _this.getChartData(model, results);
                    _this.onChartDataPrepared();
                    _this.isLoading = false;
                });
            }
            else {
                var url = this.getUrl(model, model.multiQueryFilters[0]);
                this.queriesService.getGroupedDataUri(url)
                    .then(function (result) {
                    var e_1, _a;
                    if (model.nameProperty.type == DataType.Date) {
                        try {
                            for (var _b = __values(Object.keys(result[0])), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var key = _c.value;
                                var date = moment(key, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY");
                                if (date != "Invalid date") {
                                    var newKey = date;
                                    result[0][newKey] = result[0][key];
                                    delete result[0][key];
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    _this.chartData = _this.mapToChartDataDynamic(result, _this.yConverter);
                    _this.onChartDataPrepared();
                    _this.isLoading = false;
                });
            }
        }
    };
    ChartWidget.prototype.mapToChartDataDynamic = function (data, format) {
        var e_2, _a;
        if (format === void 0) { format = null; }
        var chartData = { chartDataEntries: [] };
        if (data && data.length > 0) {
            try {
                for (var _b = __values(Object.keys(data[0])), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    var valueData = data[0][key];
                    var nameData = key;
                    if (this.isNumeric(valueData) && nameData) {
                        var chartEntry = {
                            label: nameData == '-' ? '' : nameData,
                            data: valueData,
                            formatData: format ? format(valueData) : valueData.toString()
                        };
                        chartData.chartDataEntries.push(chartEntry);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return chartData;
    };
    ChartWidget.prototype.isNumeric = function (n) {
        return isFinite(n) && parseFloat(n) == n;
    };
    ChartWidget.prototype.getUrl = function (model, config) {
        var e_3, _a;
        var url = "/odata/" + model.entityTypeUri.replace(/\s/g, "") + "/Genesis.GroupBy(column='" + model.nameProperty.name + "',propertyForAggregation='" +
            (model.aggrigationProperty ? model.aggrigationProperty.name : "") + "',aggregationType='" + model.aggrigationType + "')";
        var converterInitialFilters = new QueryFilterUriConverter(this.initFilterConverter, config.queryFilters ? config.queryFilters : [], 0, 1000, Enumerable.from(config.columns).where(function (x) { return x.isSortable; }).toArray());
        url = converterInitialFilters.getUri(true, true, url);
        if (model.limit) {
            url += "&$limit=" + model.limit;
        }
        var sorting = Enumerable.from(config.columns).where(function (x) { return x.isSortable; }).where(function (x) { return x.isAscending != null; }).orderBy(function (x) { return x.sortOrder; }).orderBy(function (x) { return x.isGrouping; })
            .toArray();
        if (sorting && sorting.length > 0) {
            url += "&$orderby=";
            try {
                for (var sorting_1 = __values(sorting), sorting_1_1 = sorting_1.next(); !sorting_1_1.done; sorting_1_1 = sorting_1.next()) {
                    var order = sorting_1_1.value;
                    url += order.name + " " + (order.isAscending ? "asc" : "desc") + " ,";
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (sorting_1_1 && !sorting_1_1.done && (_a = sorting_1.return)) _a.call(sorting_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            url = url.substring(0, url.length - 1);
        }
        if (model.resultSort && model.resultSort != null && model.resultSort != " ")
            url += "&$resultSort=" + (model.resultSort == "ascending" ? "asc" : "desc");
        return url;
    };
    ChartWidget.prototype.onChartDataPrepared = function () {
        var _this = this;
        if (this.model.aggrigationType == "average") {
            this.chartData.chartDataEntries.forEach(function (entry) {
                if (Array.isArray(entry.data)) {
                    for (var index = 0; index < entry.data.length; index++) {
                        entry.data[index] = Math.round(entry.data[index]);
                    }
                }
                else {
                    entry.data = Math.round(entry.data);
                }
            });
        }
        //setting the color for the label depending on the selected colors in congfiguration 
        this.chartData.chartDataEntries.forEach(function (entry) {
            var labelColor = Enumerable.from(_this.model.chartLabelColors).firstOrDefault(function (labelColor) { return labelColor.label.toLowerCase() == entry.label.toLowerCase(); });
            entry.color = labelColor ? "#" + labelColor.color : null;
        });
    };
    ChartWidget.prototype.getChartData = function (model, filterResult) {
        var e_4, _a;
        var labels = [];
        filterResult.forEach(function (res) {
            labels = labels.concat(Object.keys(res.result[0]));
        });
        labels = Enumerable.from(labels).distinct().toArray();
        var chartData = {
            labels: labels,
            chartDataEntries: []
        };
        var _loop_1 = function (result) {
            if (model.nameProperty.type == DataType.Date) {
                var date = moment(result.title, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY");
                if (date != "Invalid date")
                    result.title = date;
            }
            chartData.chartDataEntries.push({
                label: result.title,
                data: labels.map(function (x) {
                    if (!result.result[0][x])
                        return 0;
                    return !isNaN(parseFloat(result.result[0][x])) && isFinite(result.result[0][x]) ?
                        result.result[0][x] % 1 === 0 ? result.result[0][x] : Number(result.result[0][x]).toFixed(2)
                        : result.result[0][x];
                }),
                formatData: Enumerable.from(labels).sum(function (x) { return result.result[0][x] ? Number(result.result[0][x]) : 0; }).toFixed(0),
            });
        };
        try {
            for (var filterResult_1 = __values(filterResult), filterResult_1_1 = filterResult_1.next(); !filterResult_1_1.done; filterResult_1_1 = filterResult_1.next()) {
                var result = filterResult_1_1.value;
                _loop_1(result);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (filterResult_1_1 && !filterResult_1_1.done && (_a = filterResult_1.return)) _a.call(filterResult_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return chartData;
    };
    ChartWidget.prototype.view = function (event) {
        // disabled for the time being until we manage to test it well 
        // return;
        var e_5, _a, e_6, _b;
        var _this = this;
        var selectedUri = this.model.entityTypeUri;
        //getting the index of the query if it is stacked chart, i.e. it has multiple queries,
        //otherwise there is only one query so index is 0
        var index = event && event.detail && event.detail.index ? event.detail.index : 0;
        var queryData = CloneUtility.cloneObject(this.model.multiQueryFilters[index]);
        if (!queryData.columns)
            queryData.columns = [];
        if (event && event.detail) {
            if (!this.operators || !this.filterProperties) // in case these are not populated do noting 
                return;
            //in the case of funnel chart if user clicks all we should not filter 
            if (!event.detail.all) {
                var isLegendAndStacked = event.detail.isLengend && (this.type == ChartTypes.StackedHorizontalBar || this.type == ChartTypes.StackedBar);
                if (!isLegendAndStacked) {
                    var label = event.detail.label;
                    //in the case that a drill down rule is defined we need to drill down differntly to another query
                    if (this.drillDownRuleToApply && this.drillDownQueryModel) {
                        selectedUri = this.drillDownQueryModel.uri;
                        var columns = [];
                        var list = this.drillDownQueryModel.projectionProperties;
                        if (!this.drillDownRuleToApply.columnsToShow) {
                            this.drillDownRuleToApply.columnsToShow = [];
                        }
                        var _loop_2 = function (item) {
                            var column = QueriesEditor.generateDefaultColumn(item, this_1.drillDownQueryModel);
                            column.isHidden = !this_1.drillDownRuleToApply.columnsToShow.some(function (x) { return item.name == x; });
                            columns.push(column);
                        };
                        var this_1 = this;
                        try {
                            for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                                var item = list_1_1.value;
                                _loop_2(item);
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        queryData = {
                            columns: columns,
                            queryFilters: this.drillDownRuleToApply.queryFilters ? this.drillDownRuleToApply.queryFilters : [],
                            title: "Drill Down"
                        };
                        var propertyToFilterOn = Enumerable.from(this.drillDownQueryModel.filterProperties).first(function (x) { return x.name == _this.drillDownRuleToApply.propertyToFilterDrillDownOn; });
                        var operatorForDrilLDown = Enumerable.from(this.operators[propertyToFilterOn.type]).firstOrDefault(function (x) { return x.friendlyName == "="; });
                        var filter = QueryFilter.getQuery(propertyToFilterOn.name, label, operatorForDrilLDown.translatedSymbol, propertyToFilterOn.type, true, false, null, false, operatorForDrilLDown.requiresInterpolation);
                        filter.filterProperty = propertyToFilterOn;
                        if (filter.filterProperty) {
                            queryData.queryFilters.push(filter);
                        }
                        //now also copy other filters 
                        if (this.drillDownRuleToApply.otherPropertyToFilterToClone) {
                            var _loop_3 = function (filter_1) {
                                var currentQuery = this_2.model.multiQueryFilters[index];
                                var currentFilter = Enumerable.from(currentQuery.queryFilters).firstOrDefault(function (x) { return x.filterProperty.name == filter_1.from; });
                                if (currentFilter) {
                                    var otherPropertyToFilterOn = Enumerable.from(this_2.drillDownQueryModel.filterProperties).first(function (x) { return x.name == filter_1.to; });
                                    currentFilter.filterProperty = otherPropertyToFilterOn;
                                    queryData.queryFilters.push(currentFilter);
                                }
                            };
                            var this_2 = this;
                            try {
                                //this will borrow filters from the previous query and just replace the name 
                                for (var _c = __values(this.drillDownRuleToApply.otherPropertyToFilterToClone), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var filter_1 = _d.value;
                                    _loop_3(filter_1);
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                        }
                    }
                    // this is for normal drill downs with no rule 
                    else {
                        var operator = Enumerable.from(this.operators[this.model.nameProperty.type]).firstOrDefault(function (x) { return x.friendlyName == "="; });
                        queryData = CloneUtility.cloneObject(this.model.multiQueryFilters[index]);
                        if (!queryData.queryFilters) {
                            queryData.queryFilters = [];
                        }
                        var filter = QueryFilter.getQuery(this.model.nameProperty.name, label, operator.translatedSymbol, this.model.nameProperty.type, true, false, null, false, operator.requiresInterpolation);
                        filter.filterProperty = filter.filterProperty ? filter.filterProperty : Enumerable.from(this.nameProperties).firstOrDefault(function (x) { return x.name == _this.model.nameProperty.name; });
                        if (filter.filterProperty) {
                            queryData.queryFilters.push(filter);
                        }
                    }
                }
            }
        }
        this.cache.put(CacheKeys.selectedFilters, queryData, CacheLocation.SessionStorage);
        this.dialogClientService.show(DialogServiceConstants.URLs.ViewQueryDialog, { uri: selectedUri, title: this.title }, true, true);
    };
    ChartWidget = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [QueriesClientService,
            EntityTypeConfigurationHelper,
            InitFilterValueConverter,
            CacheClient,
            DialogClientService,
            SignalClientService])
    ], ChartWidget);
    return ChartWidget;
}(BaseWidget));
export { ChartWidget };
